import { REDUCER_NAME } from './const';
import { selectOwnState as selectParentState } from '../selector';

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME];
}

export const selectPartner = state => {
    return selectOwnState(state).partner;
}

export const selectError = state => {
    return selectOwnState(state).error;
}

export const selectValidationMessageList = state => {
    return selectOwnState(state).validationMessageList;
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged;
}

export const selectStoreList = state => {
    return selectOwnState(state).storeList;
}

export const selectRedirect = state => {
    return selectOwnState(state).redirect;
}


// WEBPACK FOOTER //
// ./src/modules/partner/state/detail/selector.js